import React from 'react';

export const Header = () => {
  return <h2>STOCKY</h2>;
};
